module.exports = __webpack_public_path__ + "img/exclusive.e57ff49.svg";